import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import router from './plugins/router';

Vue.config.productionTip = false;

new Vue({
  vuetify,
  router,
  render: (h: any) => h(App),
} as any).$mount('#app');
